import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';

const SrNavbarTitle = ({ title }) => {
  return (
    <div className="SrNavbarTitle">
      <div className="titleWrapper">
        <SrText font="whitney-sc" weight="bold" className="title">
          {title}
        </SrText>
      </div>
    </div>
  );
};

SrNavbarTitle.displayName = 'SrNavbarTitle';

SrNavbarTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SrNavbarTitle;
